<template>

  <el-dialog
      title="印模图宽高"
      append-to-body
      :visible.sync="visible"
      width="500px"
      v-loading="loading"
      :before-close="handleClose">

    <el-form :model="item" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
      <el-row class="mt20">
          <el-col :span="24">
              <el-form-item prop="width" class="pass-form" label="印模图宽度">
                  <el-input type="number" :maxlength="6" v-model="item.width"
                            placeholder="请输入印模图高度"></el-input>
              </el-form-item>
          </el-col>
          <el-col :span="24">
              <el-form-item prop="height" class="pass-form" label="印模图高度">
                  <el-input type="number" :maxlength="6" v-model="item.height"
                            placeholder="请输入印模图高度"></el-input>
              </el-form-item>
          </el-col>
      </el-row>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="updateDialog(false)">取 消</el-button>
      <el-button type="primary" @click="handleSubmit()">确 定</el-button>
    </span>

  </el-dialog>

</template>

<script>

export default {
  name: "sealwidthAndHeight",
  props:{
    visible: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      loading: false,
      ruleForm:{
        width: '',
        height: '',
      },
      rules: {
        width: [
          { required: true, message: '印模图宽度不能为空', trigger: 'blur'}
        ],
        height: [
          { required: true, message: '印模图宽度不能为空', trigger: 'blur'}
        ],
      },
      type: '',
      item: {},
      index: null,
    };
  },
  methods:{
    handleSubmit(){
      this.$refs.ruleForm.validate((value) => {
        if (value) {
          this.$emit('uploadSeal' , {type: this.type , item: this.item , index: this.index})
        }
      });
    },
    open(type,item,index){
      this.type = type
      this.item = item
      this.index = index

      // this.$refs.upload.submit()
    },
    handleClose() {
      this.$confirm('确认关闭？')
          .then(()=> {
            this.updateDialog(false)
          })
          .catch(() => {});
    },
    /* 更新visible */
    updateDialog(value) {
      this.$emit('update:visible', value);
    }
  }
}
</script>

<style scoped lang="less">

</style>
